import { insertElements } from 'lib-knowledge-document-structure/plate/common';
import {
  ELEMENT_INLINE_IMAGE,
  MyEditor,
} from 'lib-knowledge-document-structure/plateTypes';
import { BasePoint } from 'lib-knowledge-document-structure/slate/package';
import { proxy } from 'valtio';

export type State = {
  point: BasePoint | null;
};

const initialState: State = {
  point: null,
};

export const inlineImageState = proxy<State>(initialState);

export const inlineImageActions = {
  show({ point }: { point: BasePoint }): void {
    inlineImageState.point = point;
  },
  hide(): void {
    inlineImageState.point = null;
  },
  insert({
    url,
    height,
    width,
    editor,
  }: {
    url: string;
    width?: number; // in px
    height?: number; // in px
    editor: MyEditor;
  }): void {
    if (!inlineImageState.point) return;

    insertElements(
      editor,
      {
        type: ELEMENT_INLINE_IMAGE,
        url,
        width: width ? Math.min(640, width) : undefined,
        originalWidth: width,
        originalHeight: height,
        children: [{ text: '' }],
      },
      {
        at: inlineImageState.point,
        select: true,
      },
    );
    inlineImageState.point = null;
  },
};
